<template>
  <div class="panel contact-panel">
    <div class="panel-content">
      <h2 class="panel-title">Seleccioneu l'idioma</h2>
      <div>Selecciona l'idioma amb el que vols visualtizar el geoportal</div>
      <div class="q-pa-md notranslate" style="max-width: 350px">
        <q-list bordered>
          <q-item clickable
           v-for="lang of languages" :key="lang.code"
           @click="changeLanguage(lang.code)"
          >
            <q-item-section avatar>
              <flag :iso="lang.icon" style="font-size:20px; border-radius:40px"/>
            </q-item-section>
            <q-item-section>{{lang.language}}</q-item-section>
          </q-item>
        </q-list>
      </div>
    </div>
  </div>
</template>

<script>
import { QList, QItem, QItemSection } from 'quasar'

export default {
  name: 'LanguagePanel',
  components: {
    QList,
    QItem,
    QItemSection
  },
  data () {
    return {
      // check icons code from Vue-Flag-Icon
      languages: [
        { language: 'Català', code: 'ca', icon: 'es-ct' },
        { language: 'Español', code: 'es', icon: 'es' },
        { language: 'Français', code: 'fr', icon: 'fr' },
        { language: 'English', code: 'en', icon: 'gb' },
        { language: 'Deutsch', code: 'de', icon: 'de' },
        { language: 'Русский', code: 'ru', icon: 'ru' },
        { language: '日本語', code: 'ja', icon: 'jp' }
      ],
      selectedField: 'ca'
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.googleTranslateElementInit()
    })
  },
  methods: {
    notranslateToIcons: function () {
      // Add no translate to icons
      var htmlCollection = document.getElementsByClassName('q-icon')
      for (let element of htmlCollection) {
        if (!element.className.includes('notranslate')) {
          element.className += ' notranslate'
        }
      }
    },
    googleTranslateElementInit: function () {
      let checkIfGoogleLoaded = setInterval(() => {
        if (window.google.translate.TranslateElement != null) {
          clearInterval(checkIfGoogleLoaded)
          /* eslint-disable no-new */
          new window.google.translate.TranslateElement({
            pageLanguage: 'ca'
          }, 'google_translate_element')
          this.notranslateToIcons()
        }
      }, 500)
    },
    changeLanguage: function (code) {
      var language = code
      var selectField = document.querySelector('#google_translate_element select')
      for (let i = 0; i < selectField.children.length; i++) {
        let option = selectField.children[i]
        // find desired langauge and change the former language of the hidden selection-field
        if (option.value === language) {
          selectField.selectedIndex = i
          // trigger change event afterwards to make google-lib translate this side
          selectField.dispatchEvent(new Event('change'))
          break
        }
      }
      // trigger change event afterwards to make google-lib translate this side
      selectField.dispatchEvent(new Event('change'))
    }
  }
}
</script>

<style lang="scss">
// Not display google translate bar
.goog-te-banner-frame.skiptranslate {
  display: none !important;
}
body {
  top: 0px !important;
}
.contact-panel {
  .contact-title {
    font-weight: bold;
  }
}
</style>
